import React from 'react';
import { createContext, useState } from 'react';
import { Theme } from '../analytics';

interface IAnalyticsContext {
  clientId?: string;
  setClientId: (clientId: string) => void;
  accountId?: string;
  setAccountId: (accountId: string) => void;
  theme?: Theme;
  setTheme: (theme: Theme) => void;
  loggedIn?: boolean;
  setLoggedIn: (loggedIn: boolean) => void;
}

export const defaultAnalyticsContext: IAnalyticsContext = {
  loggedIn: false,
  setClientId: () => {},
  setAccountId: () => {},
  setTheme: () => {},
  setLoggedIn: () => {}
};

export const AnalyticsContext = createContext<IAnalyticsContext>(defaultAnalyticsContext);

export const AnalyticsProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [clientId, setClientId] = useState<string>();
  const [accountId, setAccountId] = useState<string>();
  const [theme, setTheme] = useState<Theme>();
  const [loggedIn, setLoggedIn] = useState<boolean>();

  return (
    <AnalyticsContext.Provider value={{ loggedIn, setLoggedIn, clientId, setClientId, accountId, setAccountId, theme, setTheme }}>
      {children}
    </AnalyticsContext.Provider>
  );
};
